/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Cost_ExceededInputs */

const en_conversion_error_cost_exceeded = /** @type {(inputs: Conversion_Error_Cost_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document was too costly to process. Please contact support if you believe this was a mistake.`)
};

const es_conversion_error_cost_exceeded = /** @type {(inputs: Conversion_Error_Cost_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesar este documento resultó demasiado costoso. Contacta con soporte si crees que se trata de un error.`)
};

/**
* | output |
* | --- |
* | "This document was too costly to process. Please contact support if you believe this was a mistake." |
*
* @param {Conversion_Error_Cost_ExceededInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_cost_exceeded = /** @type {((inputs?: Conversion_Error_Cost_ExceededInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Cost_ExceededInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_cost_exceeded(inputs)
	return en_conversion_error_cost_exceeded(inputs)
});